import { toast } from "react-toastify";
import axios from "axios";
import api from "../utils/api";
import { EXPERIENCE_TYPE } from "./types";
import { APIURL } from "src/utils/misc";

export function setExperience(experience) {
  return {
    type: EXPERIENCE_TYPE.SET_EXPERIENCE,
    experience,
  };
}

export function fetchExperiences() {
  return async (dispatch) => {
    try {
      const res = await api.get(`experiences/host`);
      const { data } = res.data;
      dispatch(setExperience(data));
    } catch (error) {
      console.log(error.message);
      toast.error("error.message");
    }
  };
}

export const addExperience = (data, navigate) => {
  return async (dispatch) => {
    let res;
    try {
      res = await api.post(`experiences/host`, data);
      if (res.data.message === "Experience with name already exist!") {
        toast.error("Experience with name already exist!");
      } else {
        dispatch({
          type: EXPERIENCE_TYPE.ADD_EXPERIENCE,
          payload: res.data,
        });
        toast.success("Experience was added successfully!");
        navigate("/app/experience/uploadImages", { replace: true });
      }
    } catch (error) {
      if (error.message === "Network Error") {
        toast.error("Check your network connection");
      } else {
        toast.error(
          "We are working on it, please try again while we implement"
        );
      }
    }
  };
};

export const getExperienceById = (data, navigate) => {
  return async (dispatch) => {
    try {
      const res = await api.get(`experiences/${data}`);
      dispatch({
        type: EXPERIENCE_TYPE.GET_EXPERIENCE,
        payload: res.data.data,
      });
      navigate("/app/experience/edit");
    } catch (error) {
      toast.error("Faile to fetch experience");
    }
  };
};

export const editExperience = (data, experienceId, navigate) => {
  return async (dispatch) => {
    try {
      const res = await api.patch(
        `experiences/host/experience/${experienceId}`,
        data
      );
      dispatch({
        type: EXPERIENCE_TYPE.GET_EXPERIENCE,
        payload: res.data.experience,
      });
      toast.success("Experience was uploaded successfully!");
      navigate("/app/experiences", { replace: true });
    } catch (error) {
      toast.error("Please check your network connections");
    }
  };
};

export const editExperienceImages = (data, experienceId, navigate) => {
  return async (dispatch) => {
    try {
      const res = await api.put(`experiences/${experienceId}/images`, data);
      dispatch({
        type: EXPERIENCE_TYPE.GET_EXPERIENCE,
        payload: res.data.experience,
      });
      toast.success("Experience was uploaded successfully!");
      navigate("/app/experiences", { replace: true });
    } catch (error) {
      toast.error("Please check your network connections");
    }
  };
};

export const uploadExperienceCoverImage = (data) => async () => {
  try {
    const res = await axios.post(`${APIURL}homes/mult_file_upload`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data[0].image_url;
  } catch (error) {
    toast.error("File upload failed!");
  }
};

export const deleteImageFile = (data) => async () => {
  try {
    const res = await api.post(`experiences/deleteImage`, data);
    return res.data;
  } catch (error) {
    toast.error("Action  failed!");
  }
};
